import React from 'react';
import './MapLocationBlock.css';

const MapLocationBlock = ({ section, isRightAligned }) => {
  if (!section) return null;

  // Variáveis dinâmicas de alinhamento
  const alignClass = isRightAligned ? "section-header-right mb-5 pb-4" : "mb-5 pb-4";
  const revealDirection = isRightAligned ? "reveal-from-left" : "reveal-from-right";

  // Pega a URL do backend do .env
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const opacityValue = (section.background_opacity || 100) / 100;

  const imageUrl = section.background_image_url 
    ? `${backendUrl}${section.background_image_url}`
    : 'https://via.placeholder.com/600x450/BCB3A3/FFFFFF?text=Mapa+do+Empreendimento';

  // ==== MÁGICA DE LOCALIZAÇÃO AUTOMÁTICA ====
  // Pega o texto do endereço e transforma em formato de URL
  const addressText = section.content || 'Jurerê Internacional, Florianópolis - SC';
  const encodedAddress = encodeURIComponent(addressText);
  
  // Gera o iframe do mapa e o link de rota nativamente
  const dynamicMapIframe = `https://maps.google.com/maps?q=${encodedAddress}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  
  // Link que abre direto na função "Rotas/Trajeto" do Google Maps
  const googleMapsRouteUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;

  // ==== BACKGROUND DINÂMICO (Padrão Unificado) ====
  const dynamicStyle = {
    position: 'relative',
  };

  if (section.background_type === 'color' || (!section.background_image_url && section.background_color)) {
    dynamicStyle.backgroundColor = section.background_color;
  }

  return (
    <section 
      id={section.slug} 
      className={`py-5 ${(!section.background_color && !section.background_image_url) ? 'default-section' : ''}`} 
      style={dynamicStyle}
    >
      {/* CAMADA 0: Imagem com bg-parallax */}
      {section.background_type === 'image' && section.background_image_url && (
        <div className="bg-parallax" style={{ 
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', 
          backgroundImage: `url(${backendUrl}${section.background_image_url})`,
          backgroundSize: 'cover', backgroundPosition: 'center', zIndex: 0 
        }}></div>
      )}

      {/* CAMADA 1: Overlay */}
      {section.background_type === 'image' && section.background_image_url && (
        <div style={{ 
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', 
          backgroundColor: 'rgba(255, 255, 255, 0.99)', 
          opacity: opacityValue, zIndex: 1 
        }}></div>
      )}

      {/* CAMADA 2: Container de Conteúdo (Sempre com zIndex: 2) */}
      <div className="container py-5" style={{ position: 'relative', zIndex: 2 }}>
        
        {/* APENAS UMA DIV COM A CLASSE DINÂMICA */}
        <div className={alignClass}>
          <h2 className={`fonte-primaria display-4 section-title reveal-element ${revealDirection} duration-10`}>
            {section.title}
          </h2>
          <h4 className={`fonte-terciaria section-subtitle mb-4 reveal-element ${revealDirection} duration-12`}>
            {section.subtitle}
          </h4>
        </div>

        {/* Trocamos 'align-items-center' por 'align-items-stretch' para forçar a mesma altura */}
        <div className="row g-4 align-items-stretch mb-5">
          
          {/* Coluna 1: Imagem do MKT */}
          <div className="col-md-6 order-2 order-md-1">
            <div className="card h-100 border-0 shadow-sm location-card p-2">
              {/* height 100% e objectFit 'cover' cravam a imagem no tamanho do card */}
              <img 
                src={imageUrl} 
                className="rounded" 
                alt="Mapa estilizado de localização Jurerê Blue" 
                style={{ width: '100%', height: '100%', minHeight: '450px', objectFit: 'cover' }}
              />
            </div>
          </div>

          {/* Coluna 2: Google Maps Dinâmico */}
          <div className="col-md-6 order-1 order-md-2">
            <div className="card h-100 border-0 shadow-sm location-card p-0 overflow-hidden">
                <iframe 
                  title="Google Maps Jurerê Blue"
                  src={dynamicMapIframe}
                  width="100%" 
                  height="100%" 
                  style={{ border: 0, minHeight: '450px', borderRadius: '8px' }} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
          </div>
        </div>

        {/* Rodapé da Seção: Endereço e Botão Google Maps */}
        <div className="bg-white rounded-pill py-4 px-5 shadow-sm d-flex flex-column flex-md-row align-items-center justify-content-between mx-auto mt-4" style={{ maxWidth: '1000px' }}>
          
          <div className="d-flex align-items-center text-start mb-3 mb-md-0">
            <i className="bi bi-geo-alt-fill fs-3 me-3" style={{ color: 'var(--cor-secundaria-3)' }}></i>
            <h5 className="mb-0 fw-bold" style={{ color: 'var(--cor-primaria-5)' }}>
              {addressText}
            </h5>
          </div>
          
          <a 
            href={googleMapsRouteUrl} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn waze-btn px-4 py-3 shadow-sm text-nowrap"
          >
            <i className="bi bi-google me-2"></i> VEJA PELO GOOGLE MAPS
          </a>
          
        </div>

      </div>
    </section>
  );
};

export default MapLocationBlock;